import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetFinixCardsRequestSchema,
  TGetFinixCardsResponseSchema,
} from "./getFinixCards.schema";

export const getFinixCards = (axios: IAxiosInstance) => {
  return async (params: TGetFinixCardsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetFinixCardsResponseSchema>
    >(`/api/business-cards/cards`, { params });

    return response.data;
  };
};
